export interface PortfolioContext {
  activesContactsCount: number;
}

export const defaultPortfolioContext = {
  activesContactsCount: 0,
};
